export const departmentListSelector = (state) => state.department.departmentList;
